import {Preview} from 'app/Components'
import {Dictionary} from 'lib/dictionaries'
import {Source} from 'lib/select'
import * as React from 'react'
import {connect} from 'react-redux'

type SpecialtiesPreviewProps = {
    ids: string[]
}

class SpecialtiesPreviewComponent extends React.Component<SpecialtiesPreviewProps> {
    public render = () => <Preview
        value={this.props.ids}
        source={Source.SPECIALTIES}
        template={(dictionary: Dictionary) => <>{dictionary.name}</>}
    />
}

export const SpecialtiesPreview = connect()(SpecialtiesPreviewComponent)